var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.50004 4.83337C5.32571 4.83337 4.33337 5.82571 4.33337 7.00004C4.33337 8.17437 5.32571 9.16671 6.50004 9.16671C7.67437 9.16671 8.66671 8.17437 8.66671 7.00004C8.66671 5.82571 7.67437 4.83337 6.50004 4.83337ZM6.50004 8.08337C5.92317 8.08337 5.41671 7.57692 5.41671 7.00004C5.41671 6.42317 5.92317 5.91671 6.50004 5.91671C7.07692 5.91671 7.58337 6.42317 7.58337 7.00004C7.58337 7.57692 7.07692 8.08337 6.50004 8.08337Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8334 3.20837L9.43262 3.20837L7.96633 1.74208C7.86504 1.64025 7.72746 1.58337 7.58337 1.58337L5.41671 1.58337C5.27262 1.58337 5.13504 1.64025 5.03375 1.74208L3.56746 3.20837L2.16671 3.20837C1.56925 3.20837 1.08337 3.69425 1.08337 4.29171L1.08337 10.25C1.08337 10.8475 1.56925 11.3334 2.16671 11.3334L10.8334 11.3334C11.4308 11.3334 11.9167 10.8475 11.9167 10.25L11.9167 4.29171C11.9167 3.69425 11.4308 3.20837 10.8334 3.20837ZM2.16671 10.25L2.16671 4.29171H3.79171C3.93579 4.29171 4.07337 4.23483 4.17467 4.133L5.64096 2.66671L7.35912 2.66671L8.82542 4.133C8.92671 4.23483 9.06429 4.29171 9.20837 4.29171H10.8334L10.8345 10.25L2.16671 10.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountWhite);
export default __webpack_public_path__ + "static/media/accountWhite.5fadba6be3bdc4e4415bdc8ea61e0a23.svg";
export { ForwardRef as ReactComponent };